module.exports = __webpack_public_path__ + "static/media/lottie-confetti.bac903c2.gif";